import { styled, IconButton } from "@mui/material";
import { mapSizesIconContainer, mapSizes } from "./constants.js";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledIconButton = styled(
  IconButton,
  shouldNotForwardProps(["size"])
)(({ theme, size = "medium" }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: mapSizesIconContainer[size],
  height: mapSizesIconContainer[size],
  padding: 0,
  svg: {
    width: mapSizes[size],
    height: mapSizes[size],
    fontSize: mapSizes[size],
    path: { fill: "currentColor!important" }
  },
  color: theme.palette.grey[800],
  "@media (hover: hover)": {
    "&:hover": {
      color: theme.palette.grey[700]
    }
  },
  "&:active": {
    color: theme.palette.grey[900]
  },
  "&.MuiIconButton-colorPrimary": {
    color: theme.palette.primary[900],
    "@media (hover: hover)": {
      "&:hover": {
        color: theme.palette.primary[800]
      }
    },
    "&:active": {
      color: theme.palette.primary[1e3]
    }
  },
  "&.MuiIconButton-colorSecondary": {
    color: theme.palette.secondary[900],
    "@media (hover: hover)": {
      "&:hover": {
        color: theme.palette.secondary[800]
      }
    },
    "&:active": {
      color: theme.palette.secondary[1e3]
    }
  },
  "&.MuiIconButton-colorInfo": {
    color: theme.palette.grey[400],
    "@media (hover: hover)": {
      "&:hover": {
        color: theme.palette.grey[500]
      }
    },
    "&:active": {
      color: theme.palette.grey[600]
    }
  },
  "&.MuiIconButton-colorInherit": {
    color: theme.palette.white.main,
    "@media (hover: hover)": {
      "&:hover": {
        color: theme.palette.grey[100]
      }
    },
    "&:active": {
      color: theme.palette.grey[200]
    }
  },
  "&:disabled": {
    color: theme.palette.grey[400],
    pointerEvents: "none"
  }
}));
export {
  StyledIconButton
};
//# sourceMappingURL=styles.js.map
